import { ErrorHandler, NgModule } from '@angular/core';
import { MatDialogModule as MatDialogModule } from '@angular/material/dialog';
import { MessageDialogModule } from '@shared/dialog/message.dialog.module';
import { AggregationErrorHandler } from './aggregation.error-handler';

@NgModule({
  imports: [MatDialogModule, MessageDialogModule],
  providers: [
    {
      provide: ErrorHandler,
      useClass: AggregationErrorHandler,
    },
  ],
})
export class ErrorHandlerModule { }
